import 'mf-ui-components/assets/AssetLoader.js';
import { SpriteSheetLoader } from './SVGSpritesheetLoader';
export var initUiLibrary = function () {
  new SpriteSheetLoader().load(window._ASSETS.flags);
  new SpriteSheetLoader().load(window._ASSETS.icons);
};